"use client";

import { createContext, useContext } from "react";

type SsoConnectionContextValue = { hasSsoConnection: boolean };

const SsoConnectionContext = createContext<SsoConnectionContextValue>({ hasSsoConnection: false });

export const SsoConnectionProvider = ({
	hasSsoConnection,
	children,
}: {
	hasSsoConnection: boolean;
	children: React.ReactNode;
}) => {
	return <SsoConnectionContext.Provider value={{ hasSsoConnection }}>{children}</SsoConnectionContext.Provider>;
};

export const useHasSsoConnection = () => {
	const context = useContext(SsoConnectionContext);
	if (context === undefined) {
		throw new Error("useHasSsoConnection must be used within a SsoConnectionProvider");
	}
	return context;
};
